import { ArrowLeft } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useContext, useEffect, useState } from "react";
import API from "../../../API/newIndex";
import { ChangePathContext } from "../../../App";
import Breadcrumbs from "../../../controllers/breadCrumbs";
import { parentNavigate } from "../../../controllers/ParentNavigate";
import Notification from "../../Notification";
import {
  ButtonComponent,
  DetailsComponent,
  InputComponent,
} from "@shopeasy-dashboard-ui/ui-library";

function AddPosLocation() {
  const { saveChanges, setSaveChanges } = useContext(ChangePathContext);
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const [addressData, setAddressData] = useState({
    addressLine1: "",
    addressLine2: "",
    country: "india",
    state: "",
    city: "",
    pincode: "",
    phone: "",
  });
  const [name, setName] = useState("");
  const [isChange, setIsChange] = useState(false);
  const handleDataFromPincode = async () => {
    try {
      const ApiCall = await API({
        url: `/super/admin/pincode/getDataFromPincode?pincode=${addressData?.pincode}`,
        method: "get",
      });
      if (ApiCall?.data) {
        const result = ApiCall?.data;
        setAddressData({
          ...addressData,
          state: result?.data?.StateName,
          city: result?.data?.District,
        });
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error?.response?.data?.error);
      setSeverity("error");
      setAddressData({
        ...addressData,
        state: "",
        city: "",
      });
    }
  };

  const handleGetDataFromPincode = async () => {
    try {
      const ApiCall = await API({
        url: `/super/admin/pincode/getLocationFromPincode?pincode=${addressData?.pincode}`,
        method: "get",
      });
      if (ApiCall?.data) {
        const result = ApiCall?.data;
        setAddressData({
          ...addressData,
          state: result?.data?.StateName,
          city: result?.data?.District,
        });
      }
    } catch (error) {
      // setIsNotification(true);
      // setNotificationMsg(error?.response?.data?.error);
      // setSeverity("error");
      handleDataFromPincode();
    }
  };
  const [err, setErr] = useState();
  const [btnLoading, setBtnLoading] = useState(false);
  const HandleSubmit = async (e) => {
    e.preventDefault();
    setBtnLoading(true);
    try {
      const body = {
        name,
        address: addressData,
      };
      const payload = body;
      await API({ url: "/admin/pos/addPOSLocation", method: "post", data: payload });
      setIsNotification(true);
      setNotificationMsg("Location Added Successfully!");
      setSeverity("success");
      setSaveChanges({
        isUnsaveChanges: false,
        showChangesPopup: false,
        backLink: "/pos/location",
        title: "add location",
      });
      parentNavigate("/pos/location");
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
    setBtnLoading(false);
  };
  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };

  useEffect(() => {
    if (isChange) {
      setSaveChanges({
        backLink: "/pos/location",
        isUnsaveChanges: true,
        showChangesPopup: false,
        title: "pos location",
      });
    }
  }, [isChange]);
  const checkChanges = () => {
    if (isChange) {
      setSaveChanges({
        isUnsaveChanges: true,
        showChangesPopup: true,
        backLink: "/pos/location",
        title: "pos location",
      });
    } else {
      parentNavigate("/pos/location");
    }
  };
  return (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}

      <div className="h-auto overflow-y-auto pb-[65px] pt-5">
        <div className="px-[20px]">
          <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto">
            <div className="flex items-center space-x-2">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  checkChanges();
                }}
                className="back-arrow -ml-3.5"
              >
                <ArrowLeft />
              </button>
              <div className="flex-1 min-w-0">
                <Breadcrumbs
                  crumbs={[
                    { name: t("lang_POS"), path: "/pos/location" },
                    {
                      name: t("lang_Add_Location"),
                      path: "/pos/location/add",
                    },
                  ]}
                />
                <div className="flex flex-wrap items-center gap-2 sm:gap-3 mt-1">
                  <h4 className="text-xl md:text-2xl font-semibold text-primary">
                    {t("lang_Add_Location")}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-[20px]">
          <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto space-y-4">
            <form onKeyDown={(e) => e.key === "Enter" && e.preventDefault()} className="space-y-4">
              <DetailsComponent
                open={true}
                hasHr={false}
                showChevron={false}
                className="!pt-5 sm:!pt-[25px]"
              >
                <div className="p-5 sm:p-[25px] pt-0 sm:pt-0 flex flex-col gap-4">
                  <InputComponent
                    id="name"
                    name="name"
                    type="text"
                    label={t("lang_name")}
                    required
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                      setIsChange(true);
                    }}
                    placeholder={t("lang_name")}
                  />
                  <InputComponent
                    id="country"
                    name="country"
                    type="text"
                    label={t("lang_Country")}
                    disabled
                    value={addressData?.country}
                    placeholder={t("lang_Country")}
                  />
                  <InputComponent
                    id="addressLine1"
                    name="oaddressLine1"
                    type="text"
                    label={t("lang_Address_line_1")}
                    value={addressData?.addressLine1}
                    onChange={(e) => {
                      setAddressData({
                        ...addressData,
                        addressLine1: e.target.value,
                      });
                      setIsChange(true);
                    }}
                    placeholder="AddressLine 1"
                  />
                  <InputComponent
                    id="addressLine2"
                    name="oaddressLine2"
                    type="text"
                    label={t("lang_Address_line_2")}
                    value={addressData?.addressLine2}
                    onChange={(e) => {
                      setAddressData({
                        ...addressData,
                        addressLine2: e.target.value,
                      });
                      setIsChange(true);
                    }}
                    placeholder="AddressLine 2"
                  />
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                    <InputComponent
                      id="Pincode"
                      name="opincode"
                      type="number"
                      label={t("lang_Pincode")}
                      required
                      value={addressData?.pincode}
                      onChange={(e) => {
                        if (e.target.value.length <= 6) {
                          setAddressData({
                            ...addressData,
                            pincode: e.target.value,
                          });
                          setIsChange(true);
                        }
                      }}
                      onBlur={() => {
                        setErr(true);
                        handleGetDataFromPincode();
                      }}
                      placeholder="Pincode"
                      error={
                        addressData?.pincode?.length > 0 &&
                          addressData?.pincode?.length !== 6 &&
                          err
                          ? t("lang_Pincode_Validation")
                          : ""
                      }
                    />
                    <InputComponent
                      id="state"
                      name="ostate"
                      type="text"
                      label={t("lang_State")}
                      required
                      disabled
                      value={addressData?.state}
                      placeholder={t("lang_State")}
                    />
                    <InputComponent
                      id="city"
                      name="ocity"
                      type="text"
                      label={t("lang_City")}
                      required
                      disabled
                      value={addressData?.city}
                      placeholder={t("lang_City")}
                    />
                  </div>
                  <InputComponent
                    id="phone"
                    name="phone"
                    type="number"
                    label={t("lang_phone")}
                    value={addressData?.phone}
                    onChange={(e) => {
                      if (e.target.value.length <= 10) {
                        setAddressData({ ...addressData, phone: e.target.value });
                        setIsChange(true);
                      }
                    }}
                    placeholder={t("lang_phone")}
                  />
                </div>
              </DetailsComponent>
            </form>
          </div>
        </div>
        <div className="flex items-center shadow fixed justify-between w-full bottom-[0px] z-50 secondary-bg-color border-t main-border-color p-3 left-0">
          <div className="w-[90%] flex items-center justify-between lg:w-[70%] xl:w-[58%] mx-auto">
            <ButtonComponent
              variant="link"
              onClick={(e) => {
                e.preventDefault();
                checkChanges();
              }}
              className="text-primary"
              icon={<ArrowLeft className="w-3 mr-1" />}
            >
              {t("lang_Go_To_POS")}
            </ButtonComponent>
            <div>
              <ButtonComponent
                variant="primary"
                loading={btnLoading}
                disabled={
                  !name ||
                  !addressData?.state ||
                  addressData?.pincode?.length < 5 ||
                  !addressData?.city
                }
                onClick={(e) => HandleSubmit(e)}
              >
                {t("lang_Add_Location")}
              </ButtonComponent>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddPosLocation;
